module.exports = __webpack_public_path__ + "img/cricket-icon.54ab83d7.png";